import api from '../../api';

// initial state
const state = {
    onLoading: true,
    data: undefined
};

// getters
const getters = {};

// actions
const actions = {
    login({ commit }, creds) {
        return api.login(creds).then(res => {
            commit('setData', res.data);
            return res;
        });
    }
};

// mutations
const mutations = {
    setData(state, data) {
        state.data = data;
        state.onLoading = false;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
